import { Divider, Grid, styled } from "@mui/material";
import React, { useState } from "react";
import DatePicker from "react-datepicker";
import Input from "../../components/Components/Input";
import CustomButton from "../../components/Components/Button";
import { useMutation } from "react-query";
import { createBarcode } from "../../components/Dashboard/mutations/materialOutward";
import ZebraBrowserPrintWrapper from "zebra-browser-print-wrapper";
import { handleToastMsg } from "../../components/Components/Toast";
import "react-datepicker/dist/react-datepicker.css";
import CustomDivider from "../../components/Components/CustomDivider"


const StyledDatePicker = styled(DatePicker)`
padding: 10px 10px;
  border: 1px solid #C4C4C4; 
  border-radius: 5px; 
  width: 86%;
`;

function BarcodeGeneration() {
  const [refNumber, setRefNumber] = useState("");
  const [testReportNo, setTestReportNo] = useState("");
  const { mutate } = useMutation(createBarcode);
  const [gatePassNo, setGatePassNo] = useState("");
  const [startDate, setStartDate] = useState(new Date());


  const printBarcode = async (serial) => {
    const browserPrint = new ZebraBrowserPrintWrapper();
    const defaultPrinter = await browserPrint.getDefaultPrinter();
    browserPrint.setPrinter(defaultPrinter);

    const printerStatus = await browserPrint.checkPrinterStatus();

    if (printerStatus.isReadyToPrint) {
      // const serial = "123456789"; // Replace this with your 9-digit serial number
      // const zpl = `^XA
      //                         ^BY1.5,1.5,100
      //                         ^FO20,20^BC^FD${serial}^FS
      //                         ^XZ`;

      console.log("newZpl");
      const newZpl = `CT~~CD,~CC^~CT~
      ^XA
      ~TA000
      ~JSN
      ^LT0
      ^MNW
      ^MTT
      ^PON
      ^PMN
      ^LH0,0
      ^JMA
      ^PR4,4
      ~SD15
      ^JUS
      ^LRN
      ^CI27
      ^PA0,1,1,0
      ^XZ
      ^XA
      ^MMT
      ^PW639
      ^LL200
      ^LS0
      ^BY2,3,93^FT26,137^BCN,,Y,N
      ^FH\^FD>;${serial}^FS
      ^PQ1,0,1,Y
      ^XZ
      `;
      browserPrint.print(newZpl);
    } else {
      handleToastMsg(`Printer error: ${printerStatus.errors}`, "error");
      console.log("Error/s", printerStatus.errors);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      invoice_num: refNumber,
      test_report_num: testReportNo,
    };
    mutate(payload, {
      onSuccess: async (res) => {
        setRefNumber("");
        setTestReportNo("");
        console.log(res.barcodeValue, "barcode");
        await printBarcode(res.barcodeValue);

        handleToastMsg("Barcode generated successfully", "success");
      },
      onError: (error) => {
        handleToastMsg(error, "error");
      },
    });
  };

  const handleReturnableSubmit = (e) => {
    e.preventDefault();

    const payload = {
      gatePassNumber: gatePassNo,
    };

    mutate(payload, {
      onSuccess: async (res) => {
        setGatePassNo("");
        await printBarcode(res.barcodeValue);

        handleToastMsg("Barcode generated successfully", "success");
      },
      onError: (error) => {
        handleToastMsg(error, "error");
      },
    });
  };

  return (
    <Grid container justifyContent={"center"} alignItems={'center'} style={{ paddingTop: '4%', paddingBottom: '20%' }}>
      <Grid item style={{ paddingBottom: '2%' }} xs={12} container justifyContent={"center"}>
        <p><b>Barcode Generation</b></p>
        <CustomDivider />

      </Grid>
      <Grid item container justifyContent={'space-between'}>
        <Grid item xs={5}>
          <form action="" style={{ width: "100%" }} onSubmit={handleSubmit}>
            <Grid item container columnGap={5} py={3}>
              <Grid item xs={3}>
                <p>Invoice number: </p>
              </Grid>
              <Grid item>
                <Input
                  type={"text"}
                  value={refNumber}
                  onChange={(e) => setRefNumber(e.target.value)}
                />
              </Grid>{" "}
            </Grid>
            <Grid item container columnGap={5} py={3}>
              <Grid item xs={3}>
                <p>Test Report No: </p>
              </Grid>
              <Grid item>
                <Input
                  type={"text"}
                  value={testReportNo}
                  onChange={(e) => setTestReportNo(e.target.value)}
                />
              </Grid>
            </Grid>
            <Grid item container justifyContent={"center"}>
              <CustomButton type="submit">Submit</CustomButton>
            </Grid>
          </form>
        </Grid>
        <Grid item xs={1} mt={10}>
          OR
        </Grid>

        <Grid item xs={5}>
          <form
            action=""
            style={{ width: "100%" }}
            onSubmit={handleReturnableSubmit}
          >
            <Grid item container columnGap={5} py={3}>
              <Grid item xs={3}>
                <p>Gate pass number: </p>
              </Grid>
              <Grid item>
                <Input
                  type={"text"}
                  value={gatePassNo}
                  onChange={(e) => setGatePassNo(e.target.value)}
                />
              </Grid>{" "}
            </Grid>
            <Grid item container columnGap={5} py={3}>
              <Grid item xs={3}>
                <p>Expected delivery date: </p>
              </Grid>
              <Grid item>
                <StyledDatePicker
                  selected={startDate}
                  onChange={(date) => setStartDate(date)}
                />
              </Grid>{" "}
            </Grid>
            <Grid item xs={12} container justifyContent={"center"}>
              <CustomButton type="submit">Submit</CustomButton>
            </Grid>
          </form>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default BarcodeGeneration;
